import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-banner-home',
  templateUrl: './banner-home.component.html',
  styleUrl: './banner-home.component.scss'
})
export class BannerHomeComponent implements OnInit, OnDestroy {
  private logoInterval: any;
  currentLogoUrl: string = '';
  isAnniversaryLogo: boolean = false;
  animationKey: number = 0;

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private router: Router,
  ) { }

  bannerData = {
    logo: {
      url: '/assets/images/logos/logo.png',
      url30years: '/assets/images/logos/logo-30-anos-padi.webp',
      alt: 'Paredes y Asociados Constructores'
    },
    content: {
      title: 'El futuro se construye con confianza',
      highlightedTitle: 'Paredes y Asociados',
      description: 'Desde hace más de 30 años, en Paredes & Asociados Constructores acompañamos a empresas e instituciones en todo México en la ejecución de proyectos industriales, comerciales y de infraestructura pública.'
    },
    buttons: {
      projects: 'Nuestros Proyectos',
      trajectory: 'Nuestra trayectoria'
    }
  };

  ngOnInit() {
    this.currentLogoUrl = this.bannerData.logo.url;

    if (isPlatformBrowser(this.platformId)) {
      this.startLogoRotation();
    }
  }

  ngOnDestroy() {
    if (this.logoInterval) {
      clearInterval(this.logoInterval);
    }
  }

  private startLogoRotation() {
    this.logoInterval = setInterval(() => {
      this.isAnniversaryLogo = !this.isAnniversaryLogo;
      this.currentLogoUrl = this.isAnniversaryLogo 
        ? this.bannerData.logo.url30years 
        : this.bannerData.logo.url;
      this.animationKey++; 
    }, 2000);
  }

  scrollToSection(sectionId: string) {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        const element = document.querySelector('#' + sectionId) as HTMLElement;
        if (element) {
          const topOfElement = element.offsetTop - 100;
          window.scroll({ top: topOfElement, behavior: 'smooth' });
        }
      }, 200);
    }
  }

  goToProjects() {
    this.router.navigate(['/proyectos']);
  }

  goToTrayectoria() {
    this.scrollToSection('trayectoria');
  }
}
